import { Container, FunctionAction, IStreamSubscription, SceneObject } from '@cgs/wge';
import { ComponentNames } from '../../../reels_engine/entity_components/component_names';
import { IReelsEngineProvider } from '../../../reels_engine/game_components_providers/i_reels_engine_provider';
import { AbstractAnticipationConfig } from '../../../reels_engine/game_config/abstract_anticipation_config';
import { ReelsEngine } from '../../../reels_engine/reels_engine';
import { T_IGameConfigProvider, T_ISlotGameEngineProvider } from '../../../type_definitions';
import { IGameConfigProvider } from '../interfaces/i_game_config_provider';
import { ResponseDependentGameComponentProvider } from '../response_dependent_game_component_provider';
import { ConditionAction } from '../win_lines/complex_win_line_actions/condition_action';

export class SingleSceneIconStopBehaviourProvider extends ResponseDependentGameComponentProvider {
  protected readonly reelsEngine: ReelsEngine;
  protected animationCounter: number = 0;
  protected readonly anticipationConfig: AbstractAnticipationConfig;

  constructor(container: Container) {
    super(container);
    this.reelsEngine =
      container.resolve<IReelsEngineProvider>(T_ISlotGameEngineProvider).reelsEngine;
    this.anticipationConfig =
      container.resolve<IGameConfigProvider>(T_IGameConfigProvider).gameConfig.anticipationConfig;
    this.createSubscriptions();
  }

  public createSubscriptions(): void {
    const reelWithStb: number[] = [];
    this.gameStateMachine.stopping.appendLazyAnimation(
      () =>
        new ConditionAction(() => {
          return this.animationCounter == 0;
        })
    );
    this.gameStateMachine.stopping.appendLazyAnimation(
      () => new FunctionAction(() => (reelWithStb.length = 0))
    );
    this.gameStateMachine.immediatelyStop.appendLazyAnimation(
      () =>
        new ConditionAction(() => {
          return this.animationCounter == 0;
        })
    );
    this.reelsEngine.entityDirectionChanged.listen((t) => {
      const reel = t.item1;
      const line = t.item2;
      if (reel < 0 || reel > 4 || line < 0 || line >= this.reelsEngine.ReelConfig.lineCount) return;
      if (
        this.anticipationConfig.stopBehaviorIcons.includes(
          this.gameStateMachine.curResponse.viewReels[reel][line]
        ) &&
        this.isWinPossible(this.gameStateMachine.curResponse.viewReels[reel][line], reel)
      ) {
        const entity = this.reelsEngine
          .getReelStoppedEntities(reel, line, false)
          .find(
            (e) =>
              e.get(
                this.reelsEngine.entityEngine.getComponentIndex(ComponentNames.DrawableIndex)
              ) == this.gameStateMachine.curResponse.viewReels[reel][line],
            { orElse: () => null }
          );
        if (!entity) {
          return;
        }
        let state = 'anticipation';
        const anticipationWithoutSoundExist = entity
          .get<SceneObject>(
            this.reelsEngine.entityEngine.getComponentIndex(ComponentNames.IconNode)
          )
          .stateMachine!.findById('anticipation2');
        if (reelWithStb.length != 0) {
          if (reelWithStb.includes(reel) && anticipationWithoutSoundExist)
            state = 'anticipation2'; //state without sound
          else reelWithStb.push(reel);
        } else reelWithStb.push(reel);

        this.reelsEngine.startAnimation(entity, state);
        let unsubscribe: IStreamSubscription;
        // eslint-disable-next-line prefer-const
        unsubscribe = entity
          .get<SceneObject>(
            this.reelsEngine.entityEngine.getComponentIndex(ComponentNames.IconNode)
          )
          .stateMachine!.findById(state)!
          .enterAction.done.listen(() => {
            this.animationCounter--;
            this.reelsEngine.stopAnimation(entity, 'anticipation');
            unsubscribe.cancel();
          });
        this.animationCounter++;
      }
    });
  }

  public isWinPossible(symbolId: number, reel: number): boolean {
    const response = this.gameStateMachine.curResponse;
    let symbolsCount = 0;
    for (let i = 0; i < reel; i++) {
      if (response.viewReels[i].includes(symbolId)) {
        symbolsCount++;
      }
    }
    const reelsLeft = this.anticipationConfig.stopBehaviorReels[
      this.anticipationConfig.stopBehaviorIcons.slice().indexOf(symbolId)
    ].filter((r) => r >= reel).length;
    return (
      reelsLeft >=
        this.anticipationConfig.minIconsForStopBehavior[
          this.anticipationConfig.stopBehaviorIcons.slice().indexOf(symbolId)
        ] ||
      this.anticipationConfig.minIconsForStopBehavior[
        this.anticipationConfig.stopBehaviorIcons.slice().indexOf(symbolId)
      ] -
        symbolsCount <=
        reelsLeft
    );
  }
}
